import { Row, Typography } from "@commonlibs";
import useTranslate from "ui/locale/hooks/useTranslate";
import clsx from "clsx";
import { useEffect } from "react";
export interface TextFieldLabelProps {
    showOptional?: boolean;
    label: string;
    required?: boolean;
    className?: string;
    style?: React.CSSProperties;
}

const TextFieldLabel = ({ label, showOptional: showOptionalProp = false, required, className, style }: TextFieldLabelProps) => {
    const translate = useTranslate();
    const showOptional = showOptionalProp && !required;

    useEffect(() => {
        if (showOptionalProp && required) {
            //eslint-disable-next-line no-console
            console.warn("TextFieldLabel: showOptional and required cannot be both true");
        }
    }, [showOptionalProp, required]);

    return (
        <Row gap="0.75rem" style={style} className={clsx(className, "text-field-label")}>
            <Typography variant="body2Strong">{label}</Typography>
            {showOptional && (
                <Typography variant="body2Strong" light>
                    {translate("optional")}
                </Typography>
            )}
        </Row>
    );
};

export default TextFieldLabel;
